module.exports = __webpack_public_path__ + "static/2-20a09411169ac04ec564dc930b684660.jpg";